import React from "react";
import { useTimezone } from "hooks/useTimezone";
import { Instant } from "@js-joda/core";
import { BROWSER_ZONE_ID, fmtDatetimeAdvanced } from "utils/time-utils";
import { Tooltip } from "react-tooltip";
import { DATE_FORMATTER_SECONDS } from "utils/constants";


export default function CompanyClock() {
  const tz = useTimezone();

  const [now, setNow] = React.useState(Instant.now());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNow(Instant.now());
    }, 1000);
    return () => clearInterval(interval);
  });

  const companyTime = fmtDatetimeAdvanced(now, tz.company, {showOffset: true, pattern: DATE_FORMATTER_SECONDS})
  const displayTime = fmtDatetimeAdvanced(now, tz.display, {showOffset: true, pattern: DATE_FORMATTER_SECONDS})
  const browserTime = fmtDatetimeAdvanced(now, BROWSER_ZONE_ID, {showOffset: true, pattern: DATE_FORMATTER_SECONDS})

  const tooltipContent = `
    Company timezone: <b>${tz.company}</b><br/>
    Display timezone: <b>${tz.display}</b><br/>
    Display time: <b>${displayTime}</b><br>
    Browser time: <b>${browserTime}</b><br>
    Company time: <b>${companyTime}</b>
  `

  return <span>
    <span data-tooltip-id="company-clock"
          data-tooltip-html={tooltipContent}
          onMouseOver={() => console.warn("mouse over")}
    >
      {companyTime}
    </span>

    <Tooltip id="company-clock" place="bottom" variant="info" opacity={1} style={{zIndex: 99999}}/>
  </span>
}